import React from 'react'
import Backdrop from './Backdrop'

const SECTIONS = [
  {
    h: 'What is Athena',
    b: 'Athena is an AI-powered business assistant developed as part of the Quantum Leap coaching platform, designed exclusively for enrolled business owners. It draws on your business context, the Quantum Leap knowledge base, and AI reasoning capability to provide strategic business support.',
  },
  {
    h: 'What Athena Does',
    b: 'Athena supports business owners with brainstorming and ideation, strategy creation and implementation planning, market and competitor research, analytical thinking and problem framing, and preparation for key business milestones such as client calls and pitches.',
  },
  {
    h: 'AI Limitations and Accuracy',
    b: 'Athena may produce responses that are inaccurate, incomplete, or misleading. You should not rely solely on Athena for critical business, legal, or financial matters. Always verify important information with your coach or a qualified professional. Use your own judgment before acting on any AI-generated output.',
  },
  {
    h: 'Not a Replacement for Your Coach',
    b: 'Athena complements your human business coach — it does not replace them. For matters involving significant risk or complex judgment, always consult your coach directly.',
  },
  {
    h: 'Your Data and Model Improvement',
    b: "Anonymised and aggregated interactions may be used to train, evaluate, and improve the underlying AI models. This data is processed in accordance with Quantum Leap's privacy policy. Personally identifiable information is not shared with third parties. Business owners may opt out by contacting Quantum Leap support.",
  },
  {
    h: 'Acceptable Use',
    b: 'Athena is for legitimate business use only. You agree not to use it to generate harmful, misleading, or unlawful content. Quantum Leap reserves the right to suspend access for misuse.',
  },
]

interface TCModalProps {
  onClose: () => void
}

export default function TCModal({ onClose }: TCModalProps) {
  return (
    <Backdrop onClose={onClose}>
      <div
        style={{
          background: 'var(--white)',
          borderRadius: 20,
          width: 540,
          maxWidth: '94vw',
          maxHeight: '86vh',
          boxShadow: 'var(--sh-lg)',
          display: 'flex',
          flexDirection: 'column',
          animation: 'mIn .4s cubic-bezier(.16,1,.3,1) both',
        }}
      >
        <div
          style={{
            padding: '20px 26px 16px',
            borderBottom: '1px solid var(--bd2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0,
          }}
        >
          <div>
            <h3
              style={{
                fontFamily: "'Playfair Display',serif",
                fontSize: 17,
                fontWeight: 500,
                color: 'var(--navy)',
              }}
            >
              Terms of Use — Athena
            </h3>
            <p style={{ fontSize: 11.5, color: 'var(--muted)', marginTop: 2 }}>
              Please read before using Athena
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              width: 28,
              height: 28,
              borderRadius: 7,
              border: '1px solid var(--bd)',
              background: 'transparent',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 15,
              color: 'var(--muted)',
            }}
          >
            ✕
          </button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 26px' }}>
          {SECTIONS.map((s) => (
            <div key={s.h} style={{ marginBottom: 20 }}>
              <h4
                style={{
                  fontSize: 10.5,
                  fontWeight: 600,
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  color: 'var(--navy)',
                  marginBottom: 7,
                }}
              >
                {s.h}
              </h4>
              <p style={{ fontSize: 12.5, color: 'var(--muted)', lineHeight: 1.75 }}>{s.b}</p>
            </div>
          ))}
        </div>
        <div
          style={{
            padding: '14px 26px 20px',
            borderTop: '1px solid var(--bd2)',
            display: 'flex',
            gap: 10,
            flexShrink: 0,
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '10px 16px',
              border: '1px solid var(--bd)',
              borderRadius: 12,
              background: 'transparent',
              fontSize: 13,
              color: 'var(--muted)',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
          <button
            type="button"
            onClick={onClose}
            style={{
              flex: 1,
              background: 'var(--navy)',
              color: 'var(--white)',
              border: 'none',
              borderRadius: 12,
              padding: 11,
              fontSize: 13.5,
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            I understand, continue →
          </button>
        </div>
      </div>
    </Backdrop>
  )
}
